import { render, staticRenderFns } from "./WaitBase.vue?vue&type=template&id=04363748&scoped=true&"
import script from "./WaitBase.vue?vue&type=script&lang=ts&"
export * from "./WaitBase.vue?vue&type=script&lang=ts&"
import style0 from "./WaitBase.vue?vue&type=style&index=0&id=04363748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04363748",
  null
  
)

export default component.exports